import { useEffect, useRef, useState } from 'react';
import type { AnimationPlaybackControls } from 'framer-motion';
import {
  runHackerHeaderTextTransition,
  stopHackerHeaderAnimation,
} from './hackerHeaderAnimation';

interface UseHackerHeaderAnimationParams {
  text: string;
}

export interface HackerHeaderAnimationState {
  displayText: string;
  isAnimating: boolean;
}

export function useHackerHeaderAnimation({
  text,
}: UseHackerHeaderAnimationParams): HackerHeaderAnimationState {
  const [displayText, setDisplayText] = useState('');
  const displayTextRef = useRef('');
  const [isAnimating, setIsAnimating] = useState(false);
  const controlsRef = useRef<AnimationPlaybackControls | undefined>(undefined);

  useEffect(() => {
    return () => {
      stopHackerHeaderAnimation(controlsRef);
    };
  }, []);

  useEffect(() => {
    stopHackerHeaderAnimation(controlsRef);

    const startText = displayTextRef.current;
    const endText = text;

    if (startText === endText) {
      setDisplayText(endText);
      setIsAnimating(false);
      return;
    }

    runHackerHeaderTextTransition({
      controlsRef,
      displayTextRef,
      endText,
      setDisplayText,
      setIsAnimating,
      startText,
    });

    return () => {
      stopHackerHeaderAnimation(controlsRef);
    };
  }, [text]);

  return {
    displayText,
    isAnimating,
  };
}
